"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputData = void 0;
var react_1 = __importStar(require("react"));
var DatePicker_1 = require("../../DatePicker/DatePicker");
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var Label_1 = require("../../Label/Label");
var HelperText_1 = require("../../HelperText/HelperText");
var estiloInputData = require("./InputData.module.scss");
var validarData = function (formatoData, mes, ano, dia) {
    if (mes < 1 || mes > 12)
        return false;
    if (formatoData === "dd/mm/aaaa" || formatoData === "mm/aaaa") {
        if (ano < 1900 || ano > 2100)
            return false;
    }
    if (formatoData === "dd/mm/aaaa" || formatoData === "dd/mm/aa") {
        var maxDiasNoMes = new Date(ano, mes, 0).getDate();
        if (dia === undefined || dia < 1 || dia > maxDiasNoMes)
            return false;
    }
    return true;
};
var useOutsideClick = function (ref, callback) {
    var handleClick = (0, react_1.useCallback)(function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
            callback();
        }
    }, [ref, callback]);
    (0, react_1.useEffect)(function () {
        document.addEventListener("mousedown", handleClick);
        return function () { return document.removeEventListener("mousedown", handleClick); };
    }, [handleClick]);
};
var DatePickerWrapper = function (_a) {
    var isOpen = _a.isOpen, formatoData = _a.formatoData, datePickerRef = _a.datePickerRef, posicaoCalculada = _a.posicaoCalculada, inputValue = _a.inputValue, cabecalhoDatePicker = _a.cabecalhoDatePicker, corpoDatePicker = _a.corpoDatePicker, etapa = _a.etapa, handleDataSelecionada = _a.handleDataSelecionada;
    var _b = (0, react_1.useState)(""), dia = _b[0], setDia = _b[1];
    var _c = (0, react_1.useState)(""), mes = _c[0], setMes = _c[1];
    var _d = (0, react_1.useState)(""), ano = _d[0], setAno = _d[1];
    (0, react_1.useEffect)(function () {
        var _a;
        var _b;
        var today = new Date();
        var diaAtual = today.getDate().toString().padStart(2, "0");
        var mesAtual = (today.getMonth() + 1).toString().padStart(2, "0");
        var anoAtual = today.getFullYear().toString();
        var dia = "";
        var mes = "";
        var ano = "";
        if (formatoData === "mm/aa" || formatoData === "mm/aaaa") {
            mes = (inputValue === null || inputValue === void 0 ? void 0 : inputValue.split("/")[0]) || mesAtual;
            ano = (_b = inputValue === null || inputValue === void 0 ? void 0 : inputValue.split("/")[1]) !== null && _b !== void 0 ? _b : anoAtual;
        }
        else {
            _a = inputValue ? inputValue.split("/") : ["", "", ""], dia = _a[0], mes = _a[1], ano = _a[2];
            if (!dia)
                dia = diaAtual;
            if (!mes)
                mes = mesAtual;
            if (!ano)
                ano = anoAtual;
        }
        if (formatoData === "dd/mm/aa" || formatoData === "mm/aa") {
            ano = ano.slice(-2);
            if (Number(ano) >= 50) {
                ano = "19".concat(ano);
            }
            else {
                ano = "20".concat(ano);
            }
        }
        dia !== "" ? setDia(dia) : "";
        mes !== "" ? setMes(mes) : "";
        ano !== "" ? setAno(ano) : "";
    }, [inputValue, formatoData]);
    if (!isOpen)
        return null;
    return (react_1.default.createElement("div", { className: "".concat(estiloInputData.datePicker, " ").concat(estiloInputData[posicaoCalculada]), ref: datePickerRef }, formatoData === "mm/aa" || formatoData === "mm/aaaa" ? (react_1.default.createElement(DatePicker_1.DatePicker, { isOpen: isOpen, mes: mes, ano: ano, cabecalhoDatePicker: cabecalhoDatePicker, corpoDatePicker: etapa, onDataSelecionada: handleDataSelecionada })) : (react_1.default.createElement(DatePicker_1.DatePicker, { isOpen: isOpen, dia: dia, mes: mes, ano: ano, cabecalhoDatePicker: cabecalhoDatePicker, corpoDatePicker: corpoDatePicker, onDataSelecionada: handleDataSelecionada }))));
};
var InputData = function (_a) {
    var id = _a.id, _b = _a.texto, texto = _b === void 0 ? "Data Inicial :" : _b, value = _a.value, _c = _a.label, label = _c === void 0 ? true : _c, _d = _a.variante, variante = _d === void 0 ? "regular" : _d, _e = _a.placeholder, placeholder = _e === void 0 ? true : _e, _f = _a.onBlur, onBlur = _f === void 0 ? function () { } : _f, _g = _a.onChange, onChange = _g === void 0 ? function () { } : _g, _h = _a.onError, onError = _h === void 0 ? function () { } : _h, _j = _a.conteudoAjuda, conteudoAjuda = _j === void 0 ? undefined : _j, _k = _a.tamanho, tamanho = _k === void 0 ? "small" : _k, _l = _a.formatoData, formatoData = _l === void 0 ? "dd/mm/aaaa" : _l, _m = _a.desabilitado, desabilitado = _m === void 0 ? false : _m;
    var varianteStyle = estiloInputData[variante] || "";
    var inputFieldSize = estiloInputData[tamanho] || "";
    var _o = (0, react_1.useState)(value !== null && value !== void 0 ? value : ""), inputValue = _o[0], setInputValue = _o[1];
    var _p = (0, react_1.useState)(false), isOpen = _p[0], setIsOpen = _p[1];
    var posicaoDatePicker = "direita";
    var _q = (0, react_1.useState)(posicaoDatePicker), posicaoCalculada = _q[0], setPosicaoCalculada = _q[1];
    var _r = (0, react_1.useState)("mes"), etapa = _r[0], setEtapa = _r[1];
    var _s = (0, react_1.useState)("mes/ano"), cabecalho = _s[0], setCabecalho = _s[1];
    var _t = (0, react_1.useState)("dia"), corpo = _t[0], setCorpo = _t[1];
    var buttonRef = (0, react_1.useRef)(null);
    var datePickerRef = (0, react_1.useRef)(null);
    var maxLength = 10;
    useOutsideClick(datePickerRef, function () {
        setIsOpen(function () {
            if ((formatoData === "mm/aaaa" || formatoData === "mm/aa")) {
                setCabecalho("mes");
                setEtapa("mes");
            }
            return false;
        });
    });
    var mostrarDatePicker = function () {
        if (desabilitado)
            return;
        setIsOpen(function (prev) {
            if ((formatoData === "mm/aaaa" || formatoData === "mm/aa")) {
                setCabecalho("mes");
                setEtapa("mes");
            }
            return !prev;
        });
    };
    var calculatePosition = function () {
        if (datePickerRef.current) {
            var datePickerRect = datePickerRef.current.getBoundingClientRect();
            var parentElement = datePickerRef.current.parentElement;
            if (!parentElement)
                return;
            var scrollParent = parentElement;
            while (scrollParent) {
                var style = window.getComputedStyle(scrollParent);
                if (style.overflowY === 'auto' || style.overflowY === 'scroll' || style.overflowX === 'auto' || style.overflowX === 'scroll') {
                    break;
                }
                scrollParent = scrollParent.parentElement;
            }
            var scrollParentRect = (scrollParent === null || scrollParent === void 0 ? void 0 : scrollParent.getBoundingClientRect()) || {
                left: 0,
                right: window.innerWidth,
                top: 0,
                bottom: window.innerHeight,
            };
            var parentRect = parentElement.getBoundingClientRect();
            var spaceRight = scrollParentRect.right - parentRect.right;
            var spaceLeft = parentRect.left - scrollParentRect.left;
            var spaceTop = parentRect.top - scrollParentRect.top;
            var spaceBottom = scrollParentRect.bottom - parentRect.bottom;
            if (spaceRight >= datePickerRect.width) {
                setPosicaoCalculada("direita");
            }
            else if (spaceLeft >= datePickerRect.width) {
                setPosicaoCalculada("esquerda");
            }
            else if (spaceTop >= datePickerRect.height) {
                setPosicaoCalculada("superior");
            }
            else if (spaceBottom >= datePickerRect.height) {
                setPosicaoCalculada("inferior");
            }
            else {
                setPosicaoCalculada(posicaoDatePicker);
            }
        }
    };
    var handleFocus = function () {
        if (formatoData === "dd/mm/aaaa") {
            maxLength = 10;
        }
        else if (formatoData === "dd/mm/aa") {
            maxLength = 8;
        }
        else if (formatoData === "mm/aaaa") {
            maxLength = 7;
        }
        else if (formatoData === "mm/aa") {
            maxLength = 5;
        }
    };
    var handleInputChange = function (e) {
        var dataDigitada = e.target.value;
        var valorFiltrado = dataDigitada
            ? dataDigitada.replace(/[^0-9/]/g, "")
            : "";
        var barras = (valorFiltrado.match(/\//g) || []).length;
        if (barras > 2)
            return;
        if (valorFiltrado.length <= maxLength) {
            var novoValor = formatarDataDigitada(valorFiltrado);
            setInputValue(novoValor);
            onChange(novoValor);
        }
    };
    var formatarDataDigitada = function (value) {
        var somenteNumeros = value.replace(/\D/g, '');
        var novoValor = '';
        var i = 0;
        for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
            var char = value_1[_i];
            if (char === '/') {
                novoValor += '/';
            }
            else if (/\d/.test(char)) {
                novoValor += somenteNumeros[i] || '';
                i++;
            }
        }
        if (!novoValor.includes('/') && somenteNumeros.length > 2) {
            novoValor = "".concat(somenteNumeros.slice(0, 2), "/").concat(somenteNumeros.slice(2));
        }
        if (formatoData === 'dd/mm/aaaa' || formatoData === 'dd/mm/aa' && somenteNumeros.length > 4) {
            if (somenteNumeros.length > 4 && novoValor.split('/').length < 3) {
                novoValor = "".concat(somenteNumeros.slice(0, 2), "/").concat(somenteNumeros.slice(2, 4), "/").concat(somenteNumeros.slice(4));
            }
        }
        else {
            if (somenteNumeros.length > 2 && novoValor.split('/').length < 2) {
                novoValor = "".concat(somenteNumeros.slice(0, 2), "/").concat(somenteNumeros.slice(2));
            }
        }
        return novoValor;
    };
    var getDataFormat = function (formatoData) {
        if (formatoData === "dd/mm/aaaa") {
            return new Date().getFullYear().toString();
        }
        else if (formatoData === "dd/mm/aa") {
            return new Date().getFullYear().toString().slice(-2);
        }
        else {
            return new Date().getFullYear().toString();
        }
    };
    var handleBlur = function (e) {
        var _a;
        var dataDigitada = e.target.value;
        onBlur(dataDigitada);
        if (dataDigitada === "") {
            return;
        }
        var dia = "";
        var mes = "";
        var ano = "";
        var partes = dataDigitada && dataDigitada.includes("/")
            ? dataDigitada.split("/")
            : [];
        if (formatoData === "dd/mm/aaaa" || formatoData === "dd/mm/aa") {
            if (dataDigitada.includes("/")) {
                dia = partes[0];
                mes = partes[1];
                ano = (_a = partes[2]) !== null && _a !== void 0 ? _a : getDataFormat(formatoData);
            }
            else {
                dia = dataDigitada.slice(0, 2);
                mes = dataDigitada.slice(2, 4);
                ano = dataDigitada.slice(4, 8);
            }
        }
        else {
            if (dataDigitada.includes("/")) {
                mes = partes[0];
                ano = partes[1];
            }
            else {
                mes = dataDigitada.slice(0, 2);
                ano = dataDigitada.slice(2, 6);
            }
        }
        if (Number(mes) > 12) {
            mes = "12";
        }
        if (formatoData === "dd/mm/aaaa" || formatoData === "dd/mm/aa") {
            var ultimoDiaDoMes = new Date(Number(ano), Number(mes), 0).getDate();
            if (Number(dia) > ultimoDiaDoMes) {
                dia = ultimoDiaDoMes.toString();
            }
            if (dataDigitada.length >= 5) {
                var diaFormatado = dia.length === 1 ? "0".concat(dia) : dia;
                var mesFormatado = mes.length === 1 ? "0".concat(mes) : mes;
                var anoFormatado = formatoData === "dd/mm/aaaa" && ano.length === 2
                    ? "20".concat(ano)
                    : formatoData === "dd/mm/aa" && ano.length >= 3
                        ? ano.toString().slice(-2)
                        : ano;
                var dataFormatada = "".concat(diaFormatado, "/").concat(mesFormatado, "/").concat(anoFormatado);
                var dataValida = validarData(formatoData, Number(mesFormatado), Number(anoFormatado), Number(diaFormatado));
                if (dataValida) {
                    setInputValue(dataFormatada);
                    onChange(dataFormatada);
                    onError(null);
                }
                else {
                    onError("Data inválida");
                    onChange("");
                }
            }
        }
        else if (formatoData === "mm/aaaa" || formatoData === "mm/aa") {
            if (dataDigitada.length > 3) {
                var mesFormatado = mes.length === 1 ? "0".concat(mes) : mes;
                var anoFormatado = formatoData === "mm/aaaa" && ano.length === 2
                    ? "20".concat(ano)
                    : ano;
                var dataFormatada = "".concat(mesFormatado, "/").concat(anoFormatado);
                var dataValida = validarData(formatoData, Number(mesFormatado), Number(anoFormatado));
                if (dataValida) {
                    setInputValue(dataFormatada);
                    onChange(dataFormatada);
                    onError(null);
                }
                else {
                    onError("Data inválida");
                    onChange("");
                }
            }
        }
    };
    var handleDataSelecionada = function (dia, mes, ano) {
        var dataFormatada;
        if (formatoData === "dd/mm/aaaa") {
            dataFormatada = "".concat((dia !== null && dia !== void 0 ? dia : "").padStart(2, "0"), "/").concat((mes !== null && mes !== void 0 ? mes : "").padStart(2, "0"), "/").concat(ano !== null && ano !== void 0 ? ano : "");
        }
        else if (formatoData === "dd/mm/aa") {
            dataFormatada = "".concat((dia !== null && dia !== void 0 ? dia : "").padStart(2, "0"), "/").concat((mes !== null && mes !== void 0 ? mes : "").padStart(2, "0"), "/").concat((ano !== null && ano !== void 0 ? ano : "").slice(-2));
        }
        else if (formatoData === "mm/aaaa") {
            dataFormatada = "".concat((mes !== null && mes !== void 0 ? mes : "").padStart(2, "0"), "/").concat(ano ? ano : inputValue.slice(3, 7));
            // console.log(inputValue, inputValue.slice(3, 7))
        }
        else {
            dataFormatada = "".concat((mes !== null && mes !== void 0 ? mes : "").padStart(2, "0"), "/").concat(ano ? ano : inputValue.slice(3, 4));
        }
        if (dataFormatada === "") {
            setIsOpen(false);
            return;
        }
        setInputValue(dataFormatada);
        onChange(dataFormatada);
        etapa !== "mes" ? setIsOpen(false) : setEtapa(function () {
            if ((formatoData === "mm/aaaa" || formatoData === "mm/aa")) {
                setCabecalho("ano");
            }
            return "ano";
        });
    };
    (0, react_1.useLayoutEffect)(function () {
        if (isOpen) {
            calculatePosition();
            window.addEventListener('resize', calculatePosition);
            window.addEventListener('scroll', calculatePosition, true);
        }
        return function () {
            window.removeEventListener('resize', calculatePosition);
            window.removeEventListener('scroll', calculatePosition, true);
        };
    }, [isOpen]);
    (0, react_1.useEffect)(function () {
        setInputValue(value !== null && value !== void 0 ? value : "");
    }, [value]);
    (0, react_1.useEffect)(function () {
        handleInputChange({
            target: { value: value },
        });
    }, [value]);
    (0, react_1.useEffect)(function () {
        setCabecalho(function () {
            if (formatoData === "dd/mm/aaaa" || formatoData === "dd/mm/aa") {
                return "mes/ano";
            }
            else if (formatoData === "mm/aaaa" || formatoData === "mm/aa") {
                return "ano";
            }
            return "mes/ano";
        });
    }, [formatoData]);
    (0, react_1.useEffect)(function () {
        setCorpo(function () {
            if (formatoData === "dd/mm/aaaa" || formatoData === "dd/mm/aa") {
                return "dia";
            }
            else if (formatoData === "mm/aaaa" || formatoData === "mm/aa") {
                return "ano";
            }
            return "dia";
        });
    }, [formatoData]);
    return (react_1.default.createElement("div", { className: "".concat(estiloInputData.conteudo, " ").concat(conteudoAjuda && estiloInputData.temConteudoAjuda) },
        react_1.default.createElement("div", { className: estiloInputData.input },
            label && react_1.default.createElement(Label_1.Label, { texto: texto }),
            react_1.default.createElement("div", { className: "".concat(estiloInputData.inputIcone, " \n                        ").concat(varianteStyle, " \n                        ").concat(inputFieldSize) },
                react_1.default.createElement("input", { id: id, type: "text", value: inputValue, disabled: desabilitado, onChange: handleInputChange, onBlur: handleBlur, onFocus: handleFocus, placeholder: placeholder ? formatoData : "", maxLength: maxLength }),
                react_1.default.createElement("div", { className: "".concat(estiloInputData.iconeData, " ").concat(desabilitado ? estiloInputData.iconeDataDisabled : ''), ref: buttonRef, onClick: mostrarDatePicker },
                    react_1.default.createElement(Icone_1.Icone, { desabilitado: desabilitado, corOnHover: Cores_1.Cores.GradacaoPrimaria.AzulMU500, nome: "calendar", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, largura: "20px" })),
                react_1.default.createElement(DatePickerWrapper, { isOpen: isOpen, formatoData: formatoData || "dd/mm/aaaa", datePickerRef: datePickerRef, buttonRef: buttonRef, posicaoCalculada: posicaoCalculada, inputValue: inputValue || "", cabecalhoDatePicker: cabecalho, corpoDatePicker: corpo, etapa: etapa, handleDataSelecionada: handleDataSelecionada }))),
        conteudoAjuda && react_1.default.createElement(HelperText_1.HelperText, __assign({}, conteudoAjuda))));
};
exports.InputData = InputData;
